import { DateFormat } from '~/eds/src/types/DateFormat';

export enum DateFormatType {
  Default = 'MM/DD/YYYY',
  EuShort = 'DD/MM/YYYY',
  Iso = 'YYYY-MM-DD',
  Long = 'MMMM D, YYYY',
  Prose = 'Do [day of] MMMM, YYYY',
  Time = 'h:mm A',
  UsShort = 'MM/DD/YYYY',
}

export const DATE_FORMAT_TYPE_TO_DATE_FORMAT: Record<
  DateFormatType,
  DateFormat
> = {
  [DateFormatType.Default]: 'us_date', // Default and UsShort are the same key
  [DateFormatType.EuShort]: 'eu_date',
  [DateFormatType.Iso]: 'iso_date',
  [DateFormatType.Long]: 'fixed_long', // Backward compatibility: map Long to fixed_long
  [DateFormatType.Prose]: 'prose',
  [DateFormatType.Time]: 'time',
};
